module.exports = __webpack_public_path__ + "static/img/parcels.74d651e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parcels.png
// module id = yJOj
// module chunks = 1